import React, { useEffect, useState } from 'react'

import Container from '../../../../components/Container';
import PageTitle from '../../../../components/PageTitle';
import TitleBar from '../../../../components/TitleBar';

import FiscalYearList from './components/FiscalYearList';

import { listExperimentsByFiscalYear, listFiscalYears } from '../../../../sdk/apis';
import BottomBar from '../../../../components/BottomBar';
import './items.css';
import FiscalYearExperimentList from '../FiscalYearExperiments/components/FiscalYearExperimentList';


const FiscalYears = () => {
  const [years, setYears] = useState(null);
  const [experimentList, setExperimentList] = useState(null);

  useEffect(() => {
    const fetchExperimentList = async () => {
      const ys = await listFiscalYears();
      const flattenedList = await (await Promise.all(ys.map(y => listExperimentsByFiscalYear(y)))).flat();
      await setYears(ys);
      await setExperimentList(flattenedList);
    }
    fetchExperimentList();
  }, []);

  if (years === null || experimentList === null) {
    return null;
  }

  return (
    <>
      <TitleBar />
      <Container>
        <div id='container'>
          <div id='experimentList'>
            <PageTitle>実験名から選択</PageTitle>
            <FiscalYearExperimentList experiments={experimentList} />
          </div>
          <div id='fiscalYearList'>
            <PageTitle>年度から選択</PageTitle>
            <FiscalYearList years={years} />
          </div>
        </div>
      </Container>
      <BottomBar />
    </>
  );
};

export default FiscalYears;
